import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Sprout, Heart, Gift, EyeOff, Eye, Calendar, Radio, HeartHandshake, Smartphone } from "lucide-react";
import api from "@/lib/api";
import { useFeature } from "@/contexts/FeaturesContext";

/* ── Portofelul de Semințe (17.12) ── */


/* ── Inbox „cineva s-a gândit la tine" (17.20) ── */
export function LightInbox() {
  const enabled = useFeature("light_inbox");
  const [r, setR] = useState(null);
  useEffect(() => { if (enabled) api.get("/me/received").then((x) => setR(x.data)).catch(() => {}); }, [enabled]);
  if (!enabled || !r?.has) return null;
  return (
    <div className="card-premium p-6" data-testid="light-inbox" style={{ borderColor: "var(--ct-gold)" }}>
      <h3 data-el="lightinbox_title" className="font-serif text-lg mb-2 inline-flex items-center gap-2"><Gift size={16} style={{ color: "var(--ct-gold)" }} /> Cineva s-a gândit la tine</h3>
      <div className="flex flex-wrap gap-4">
        {r.seeds_received > 0 && (
          <span data-el="lightinbox_seeds" className="inline-flex items-center gap-1.5 text-sm" style={{ color: "var(--ct-link)" }}>
            <Sprout size={14} /> {r.seeds_received} {r.seeds_received === 1 ? "sămânță de înțelepciune primită" : "semințe de înțelepciune primite"}
          </span>
        )}
        {r.hearts_received > 0 && (
          <span data-el="lightinbox_hearts" className="inline-flex items-center gap-1.5 text-sm" style={{ color: "var(--ct-gold)" }}>
            <Heart size={14} /> {r.hearts_received} {r.hearts_received === 1 ? "inimă la șoapta ta" : "inimi la șoaptele tale"}
          </span>
        )}
      </div>
      <p data-el="lightinbox_note" className="text-[11px] mt-3" style={{ color: "var(--ct-text-dim)" }}>Oameni pe care nu-i cunoști au ținut la tine, anonim. Nu ești singur(ă).</p>
    </div>
  );
}
